import { Link } from "react-router-dom";

import { TableColumn } from "@/components/Table/Table";
import { LinkedinIcon } from "@/components/LinkedinIcon/LinkedinIcon";
import { WebsiteIcon } from "@/components/WebsiteIcon/WebsiteIcon";

import { SwarmPreview } from "../schema/swarmPreview";

/**
 * The columns of the Lead Database editor's preview table. Extracted from `CreateSwarm.tsx`
 * (PREC-4462) so that form stays under the file-length gate; they read only the row.
 */
export const swarmPreviewColumns: TableColumn[] = [
	{
		title: "name",
		uid: "full_name",
		render: (row: SwarmPreview) => (
			<div className="flex items-center justify-start gap-1 flex-row">
				<div className="text-sm font-medium max-w-[300px] whitespace-nowrap overflow-hidden text-ellipsis">
					{row?.profile_info.full_name}
				</div>
				{row?.profile_info.linkedin_url && (
					<Link target="_blank" to={`https://www.${row?.profile_info.linkedin_url}`}>
						<LinkedinIcon status="checked" />
					</Link>
				)}
			</div>
		),
	},
	{
		title: "Current Title",
		uid: "current_title",
		render: (row: SwarmPreview) => (
			<div className="flex items-start justify-start">
				{row?.profile_info.current_title} ({row?.profile_info.current_seniority?.join(", ")})
			</div>
		),
	},
	{
		title: "Personal Location",
		uid: "current_location",
		render: (row: SwarmPreview) => (
			<div className="flex items-start justify-start">{row?.profile_info.current_location}</div>
		),
	},
	{
		title: "Company",
		uid: "current_company_name",
		render: (row: SwarmPreview) => (
			<div className="flex items-start justify-start">
				<div className="text-sm font-medium max-w-[300px] whitespace-nowrap overflow-hidden text-ellipsis">
					{row?.profile_info.current_company_name}
				</div>
				{row?.profile_info.current_company_linkedin_url && (
					<Link
						target="_blank"
						to={`https://www.${row?.profile_info.current_company_linkedin_url}`}
					>
						<LinkedinIcon status="checked" />
					</Link>
				)}
				{row?.profile_info.current_company_website && (
					<Link target="_blank" to={`https://${row?.profile_info.current_company_website}`}>
						<WebsiteIcon status="checked" />
					</Link>
				)}
			</div>
		),
	},
	{
		title: "Industry",
		uid: "current_company_industry",
		render: (row: SwarmPreview) => (
			<div className="flex items-start justify-start">
				{row?.profile_info.current_company_industry}
			</div>
		),
	},
	{
		title: "Company Size",
		uid: "current_company_size",
		render: (row: SwarmPreview) => (
			<div className="flex items-start justify-start">
				{row?.profile_info.current_company_size?.min && row?.profile_info.current_company_size?.max
					? `${row?.profile_info.current_company_size?.min} - ${row?.profile_info.current_company_size?.max}`
					: ""}
			</div>
		),
	},
	{
		title: "Company Location",
		uid: "company_location",
		render: (row: SwarmPreview) => (
			<div className="flex items-start justify-start">
				{row?.profile_info.current_company_location}
			</div>
		),
	},
];
